<template>
    <button type="button" :class="class_list" @click="button_click">
        <i :class="icon_class" v-if="icon"></i> <slot></slot>
    </button>
</template>

<script>

    export default {
        props: {
            name: {
                default: 'btn'
            },
            class_list: {
                default: 'btn btn-primary btn-md heading-btn'
            },
            icon:{
                default: true
            },
            icon_class:{
                default:"position-left icon-plus3"
            },
            event_name:{
                default: "button_click"
            }
        },
        methods: {
            button_click() {
                bus.$emit(this.event_name, this.name);
            }
        }
    };
</script>